<template>
  <div>
    <section class="create_demo_container pc_container">
      <p>做工业数字孪生项目，就选元海数字孪生</p>
              <div class="tiyan_btn">
                   <a  href="http://nassforcecon.com:5000/d/s/16kJ3wyItEBEVPYJCiwqMzJ8aeuEH8SA/t_qF3uGGxnbIc4SWWOFsSZL32ukoelfV-OrfAWrlF6gw" target="_blank">立即下载</a>
              </div>
      <experience v-model="isShowExperienceDialog"></experience>
    </section>
    <div class="mobile_create_experience_container mobile_container">
      <section class="mobile_create_experience">
        <p class="mobile_create_text">做工业数字孪生项目，就选元海数字孪生</p>
        <!-- <div class="mobile_tiyan_btn" @click="tiyan_mobile">立即下载</div> -->
      </section>
      <mobileExperience v-model="isShowMobileExperience" />
    </div>
  </div>
</template>

<script>
import experience from '@/components/experience/index.vue'
import mobileExperience from '@/components/mobile/experience/mobile-experience.vue'
export default {
  components: {
    experience,
    mobileExperience
  },
  data() {
    return {
      isShowExperienceDialog: false,
      isShowMobileExperience: false
    }
  },
  methods: {
    tiyan() {
      this.isShowExperienceDialog = true
    },
    tiyanMobile() {
      this.isShowMobileExperience = true
    },
    experience() {
      this.$router.push({
        path: "/contact",
      });
    },
  },
};
</script>

<style scoped>
.create_demo_container {
  height: 320px;
  background: url("../../assets/images/index/contact.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* margin-top: 83px; */
}

.create_demo_container>p {
  color: #ffffff;
  font-size: 32px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  letter-spacing: 3px;
  font-style: italic;
}

.create_demo_container .tiyan_btn {
  width: 190px;
  height: 54px;
  line-height: 54px;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(90deg, #006fff 0%, #4699fa 100%);
  border-radius: 8px;
  margin-top: 61px;
  cursor: pointer;
}

.mobile_create_experience_container {
  display: none;
}

.mobile_create_experience {
  width: 1920px;
  height: 854.4px;
  background-image: url("../../assets/images/mobile/mobile_tiyan_bg_img.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.mobile_create_text {
  font-size: 85.44px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-style: italic;
  color: #FFFFFF;
}
.mobile_tiyan_btn {
  width: 600.75px;
  height: 174.18px;
  line-height: 174.18px;
  font-size: 84.08px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(90deg, #006fff 0%, #4699fa 100%);
  border-radius: 21.36px;
  margin-top: 109.47px;
  cursor: pointer;
}

.tiyan_btn a {
  /* 关键：让a标签铺满整个div */
  width: 100%;
  height: 100%;
  /* 文字样式：白色 */
  color: #ffffff;
  /* 文字居中（可选，提升体验） */
  display: flex;
  align-items: center;
  justify-content: center;
  /* 去除下划线 */
  text-decoration: none;
  /* 去除点击后的高亮框 */
  outline: none;
  /* 禁止文字选中（可选） */
  user-select: none;
}

/* 去除所有交互状态效果 */
.tiyan_btn a:hover,
.tiyan_btn a:active,
.tiyan_btn a:focus {
  /* 保持文字白色不变 */
  color: #ffffff;
  /* 无下划线 */
  text-decoration: none;
  /* 无背景变化 */
  background: transparent;
  /* 无轮廓 */
  outline: none;
  /* 去除移动端点击高亮 */
  -webkit-tap-highlight-color: transparent;
}

</style>